module.exports = ".center {\n  margin: 50px auto;\n  max-width: 600px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/confirm/confirm.scss
// module id = ./src/app/pages/confirm/confirm.scss
// module chunks = main